import { Component, OnInit, OnDestroy, AfterViewInit, Inject } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { EmployeeInfoService } from '../../../core/services/employee-info.service';
import { PortalSettingsService } from '../../../core/services/portal-settings.service';
import { HomeService } from '../../../pages/home/services/home.service';
import { EmployeeService } from './../../../pages/employee/services/employee.service';
import { BsModalService } from 'ngx-bootstrap/modal';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { EventService } from '../../services/event.service';
import { ClockinJobModalComponent } from 'src/app/modals/home/clockin-job-modal/clockin-job-modal.component';
import { ErrorModalComponent } from 'src/app/modals/shared/error-modal/error-modal.component';
import { ClockoutModalComponent } from 'src/app/modals/home/clockout-modal/clockout-modal.component';
import { PaperlessModalComponent } from 'src/app/modals/home/paperless-modal/paperless-modal.component';
import { PasswordWarningModalComponent } from 'src/app/modals/home/password-warning-modal/password-warning-modal.component';
import { WarningModalComponent } from '../../../modals/shared/warning-modal/warning-modal.component';
import { AlertModalComponent } from '../../../modals/shared/alert-modal/alert-modal.component';
import { OrderByPipe } from './../../../shared/pipe/order-by.pipe';
import moment from 'moment';
import { HttpClient, HttpRequest, HttpEvent, HttpEventType } from '@angular/common/http';
import { Subscription, timer } from 'rxjs';
import { ConfirmationModalComponent } from 'src/app/modals/home/confirmation-modal/confirmation-modal.component';
import { UtilityService } from '../../services/utility.service';
import { PortalModulesService } from '../../services/portal-modules.service';
import { ClockInOutService } from '../../services/clock-in-out.service';
import { PortalSettings } from '../../../pages/account/services/account.service';
import { EmployeeInfo, PortalModule } from '../../../type-definitions/home/responses/home';

@Component({
  selector: 'app-navigation',
  templateUrl: './navigation.component.html',
  styleUrls: ['./navigation.component.css'],
})
export class NavigationComponent implements OnInit, OnDestroy, AfterViewInit {
  pRCO: number;
  loginMode: string;
  isOver: boolean;
  portalSettings: PortalSettings;
  portalModules: PortalModule[];
  employeeInfo: EmployeeInfo;
  formData: { [key: string]: any } = {};
  requestObj: { [key: string]: any } = {};
  modules: PortalModule[];
  menu: any[] = [];
  position: GeolocationPosition;
  clockStatus: { [key: string]: any } = {};
  showTeamLinkOnNav: boolean;
  viewpointOneUrl: string;
  ViewpointAnalyticsURL: string;
  hotlistMenu: boolean;
  userNameMenu: boolean;
  teamMenu: boolean;
  unapprovedRequestCount: number;
  flagsExist = false;
  moduleCategories: any[];
  hotlistItems: PortalModule[] = [];
  moduleCategoriesMobile: any[];
  navBarClockInEnabled: boolean;
  requestingLocation = true;
  geolocationEnabled: boolean;
  performingClockAction: boolean;
  siteUrl: string;
  showPaperless: boolean;
  newFiles: any[] = [];
  isSafari = false;
  mobileIosMatches: RegExpMatchArray;
  currencySymbol: string;
  image: any = null;
  showImageNow: boolean;
  submitCount: number;
  apInvoiceShow: boolean;
  apEnabled: boolean;
  helpLink: string;
  feedbackEmail: string;
  fieldToolsCount: number = null;
  expenseReport = '/Employee/ExpenseReport';
  isExpensePage: boolean = this.window.location.pathname.indexOf(this.expenseReport.toLowerCase()) != -1;
  unapprovedPersonalInfoRoute = '/Admin/PersonalInfoRequests';
  unapprovedTimeRoute = '/Approval/Index';
  timeOffDashboard = '/Approval/ManageTimeOff';
  jobBillingReview = '/Billing/BillingReview';
  userAccess = '/Admin/ManageEmployees';
  printHuddle = '/Field/PrintHuddle';
  newReceiptID: number;
  newReceiptItemID: number;
  upload: any;
  fileData: any[];
  innerCounter: number;
  openModalLeft: number;
  isModuleAdmin: boolean;
  suggestionUrl = 'https://keystyle.ideas.aha.io/ideas';
  errorMsg: string;
  portalName: string;
  logoUrl: string;
  hideBar: boolean = this.window.location.pathname.includes(this.printHuddle.toLowerCase());
  showOfficeRoute: boolean;
  addAttachmentToReceipt = false;
  navBarNavigationEnd$: Subscription = null;
  approvalCounts: { [key: string]: number } = {};
  payLink: string;
  private readonly approvalCountRefreshInterval: number = 60 * 1000;
  private subscriptions: Subscription[] = [];
  tidEnabled = false;
  licensedUser: any = {};
  enabledLineTypesInClockIn: string;
  private approvalCountsSub: Subscription = null;

  constructor(
    private router: Router,
    portalSettingsService: PortalSettingsService,
    employeeInfoService: EmployeeInfoService,
    private homeService: HomeService,
    private employeeService: EmployeeService,
    private modalService: BsModalService,
    private ngbModalService: NgbModal,
    public HttpClient: HttpClient,
    private eventService: EventService,
    private utilityService: UtilityService,
    private portalModulesService: PortalModulesService,
    private clockinoutService: ClockInOutService,
    @Inject('Window') private window: Window
  ) {
    portalSettingsService.portalSettings$.subscribe(latestSettings => {
      this.portalSettings = latestSettings;
    });
    this.employeeInfo = employeeInfoService.getEmployeeInfo();
    this.portalModules = this.portalModulesService.getPortalModules();
  }

  ngOnInit(): void {
    this.navBarNavigationEnd$ = this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.isExpensePage = this.window.location.pathname.indexOf(this.expenseReport.toLowerCase()) != -1;
        this.closeGlobalNav();
      }
    });

    this.tidEnabled = this.portalSettings.TidEnabled.ConfigValue === '1';

    this.subscriptions.push(
      this.eventService.onSendApprovalCountReceived((approval: string, count: number) => this.updateApprovalCount(approval, count))
    );
    this.init();
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(sub => sub?.unsubscribe());
    if (this.navBarNavigationEnd$) {
      this.navBarNavigationEnd$.unsubscribe();
    }
    if (this.approvalCountsSub) {
      this.approvalCountsSub.unsubscribe();
    }
  }

  init(): void {
    this.initApprovalCounts();
    this.getUserContext();
    this.enabledLineTypesInClockIn = this.portalSettings.EnabledLineTypesInClockIn.ConfigValue;
    this.showTeamLinkOnNav = this.portalSettings.ShowTeamLinkOnNav.ConfigValue == '1';
    this.navBarClockInEnabled = this.portalSettings.NavBarClockInEnabled.ConfigValue == '1';
    this.payLink = this.portalSettings.TrimblePayLink.ConfigValue;
    this.siteUrl = 'kdstimecard://' + this.window.location.origin;

    const browserLanguage = this.utilityService.getBrowserLanguage();
    const url = browserLanguage === 'en-AU' ? 'https://au.team.viewpoint.com' : 'https://team.viewpoint.com';
    this.viewpointOneUrl = url;
    this.ViewpointAnalyticsURL = url + '/vo/analytics/' + this.portalSettings.ViewpointOneEnterpriseID.ConfigValue + '/home';

    this.showPaperless =
      this.portalSettings.ShowC1095Paperless.ConfigValue == '1' ||
      this.portalSettings.ShowW2Paperless.ConfigValue == '1' ||
      this.portalSettings.ShowPaystubPaperless.ConfigValue == '1' ||
      this.portalSettings.AllowPaperlessInfoChange.ConfigValue == '1' ||
      this.portalSettings.ShowPaperlessCarrier.ConfigValue == '1'
        ? true
        : false;
    this.addAttachmentToReceipt = this.portalSettings.EnableAddAttachmentToReceipt.ConfigValue == '1';
    if (
      this.employeeInfo.IsBulletinAdmin ||
      this.employeeInfo.IsChecklistAdmin ||
      this.employeeInfo.IsHuddleAdmin ||
      this.employeeInfo.IsOnboardAdmin ||
      this.employeeInfo.IsPurchasingAdmin ||
      this.employeeInfo.IsSecurityAdmin ||
      this.employeeInfo.IsTimecardAdmin ||
      this.employeeInfo.IsTrainingAdmin ||
      this.employeeInfo.IsTrainingClassAdmin ||
      this.employeeInfo.IsVacationAdmin ||
      this.employeeInfo.IsVacationDashAdmin
    ) {
      this.isModuleAdmin = true;
    } else {
      this.isModuleAdmin = false;
    }
    if (this.navBarClockInEnabled) {
      setTimeout(() => {
        this.getClockInStatus();
      }, 1000);
    }

    this.openModalLeft = (this.window.innerWidth - 200) / 2;
    this.formData = {};
    this.fileData = [];
    this.formData.fileDrop = null;
    this.isSafari = this.utilityService.checkSafari();
    this.mobileIosMatches = navigator.userAgent.match(/(iPad|iPhone|iPod touch);.*(OS 7_|OS 8_|OS 9_|OS 10_|OS 11_|OS 12_\d)/i);
    if (this.mobileIosMatches != null && this.isSafari) {
      $('#NavBar').addClass('mobileSafari');
    }
    this.currencySymbol = this.utilityService.getCurrencySymbol(this.employeeInfo.PRCo);
    this.feedbackEmail = this.portalSettings.FeedbackEmail.ConfigValue;
    this.apEnabled = this.portalSettings.EnableAPInvoiceReview.ConfigValue == '1';
    this.helpLink = this.portalSettings.HelpLink.ConfigValue;
    this.getModules();
    this.subscriptions.push(this.eventService.on('modulesChanged', () => this.getModules(true)));
    this.subscriptions.push(this.eventService.on('approvedTimecardsChanged', () => this.getEmployeeInfo()));
    this.subscriptions.push(this.eventService.on('approvedTimeoffChanged', () => this.modifyApprovedTimeOff()));

    // this needs to be scheduled to run every 5 minutes or so, only if the user has approval modules
    if (this.portalModules.some(m => m.ApprovalType)) {
      this.approvalCountsSub = timer(0, this.approvalCountRefreshInterval).subscribe(() => this.homeService.getApprovalCounts());
    }
  }

  ngAfterViewInit(): void {
    if (this.employeeInfo.ShowConsentForm && this.showPaperless) {
      this.openModal();
      this.paperLessModal();
    }
  }

  onKioskClicked(event: Event, href: string): void {
    this.utilityService.isLoggedOut = true;
    this.window.location.href = href;
  }

  private initApprovalCounts(): void {
    this.portalModules.forEach(module => {
      if (module.ApprovalType) {
        this.approvalCounts[module.ApprovalType] = 0;
      }
    });
  }

  // callback method when we receive a SignalR event to update an approval count
  private updateApprovalCount(approval: string, count: number): void {
    const hasApproval = Object.prototype.hasOwnProperty.call(this.approvalCounts, approval);
    if (hasApproval) {
      if (approval === 'IssueTracker') {
        this.fieldToolsCount = count;
      } else if (approval === 'JobTimeApproval') {
        // items to show flag instead of count
        this.approvalCounts[approval] = count > 0 ? -1 : 0;
      } else {
        this.approvalCounts[approval] = count;
      }

      this.calculateUnapprovedRequestCount();
    }
  }

  private calculateUnapprovedRequestCount(): void {
    this.unapprovedRequestCount = 0;
    this.unapprovedRequestCount += Object.values(this.approvalCounts)
      .map(Number)
      .filter(x => x > 0)
      .reduce((acc, val) => acc + val, 0);
    this.unapprovedRequestCount +=
      this.employeeInfo.TimecardCount +
      this.employeeInfo.PersonalInfoCount +
      this.employeeInfo.TimeOffCount;

    this.flagsExist = Object.values(this.approvalCounts).includes(-1);
  }

  getUserContext(): void {
    this.homeService.getUserContext().then((response: any) => {
      this.pRCO = response.PRCo;
      this.isOver = response.IsOver;
      this.loginMode = response.LoginMode;
      if (
        this.employeeInfo.LoginType != 'Identity' &&
        this.employeeInfo.PasswordResetStatus != null &&
        this.window.location.pathname.toLowerCase().indexOf('changeaccountpassword') == -1
      ) {
        const passwordResetSchedule = parseInt(this.portalSettings.PasswordResetSchedule.ConfigValue);
        if (
          (passwordResetSchedule > 0 || this.portalSettings.RequirePasswordChangeOnAdminUpdate.ConfigValue == '1') &&
          this.employeeInfo.PasswordResetStatus <= 0 &&
          this.loginMode == 'viewpoint'
        ) {
          this.openPasswordWarningModal();
        }
      }
      this.checkCompanyLogo();
      this.getPortalName();
    });
  }

  async getModules(refresh = false): Promise<void> {
    if (this.employeeInfo != null) {
      this.calculateUnapprovedRequestCount();
    }

    //Get Counts
    let response: PortalModule[];
    if (refresh) {
      response = await this.homeService.getModules();
    } else {
      response = this.portalModules;
    }
    if (response.find(m => m.ModuleID == 130)) {
      this.showOfficeRoute = true;
    }

    this.modules = response;
    this.groupModules();
  }

  openPayLink(): void {
    try {
      const url = new URL(this.payLink);
      this.window.open(url, '_blank');
    } catch {
      /* empty */
    }
  }

  openModal3(): void {
    document.getElementById('modalNav3').style.display = 'block';
    document.getElementById('modalNav3').style.left = this.openModalLeft + 'px';
    document.getElementById('fadeNav3').style.display = 'block';
  }

  closeModal3(): void {
    document.getElementById('modalNav3').style.display = 'none';
    document.getElementById('fadeNav3').style.display = 'none';
  }

  checkCompanyLogo(): void {
    this.homeService.getCompanyLogo(this.pRCO, 's').then(response => {
      this.image = response == '' ? null : response;
      this.showImageNow = true;
      this.logoUrl = '/Company/GetLogo?co=' + this.pRCO + '&size=S';
    });
  }

  getPortalName(): void {
    this.homeService.getPortalName(this.pRCO).then(response => {
      this.portalName = response == '' ? null : response;
    });
  }

  readFile(file, call): void {
    const reader = new FileReader();
    reader.onload = function (e): void {
      return call(e, file.name);
    };
    reader.readAsDataURL(file);
  }

  uploadFiles(val2: any): Subscription {
    val2.Filedata.upload = new HttpRequest(
      'POST',
      '/employee/AddAttachment',
      {
        receiptID: this.newReceiptID,
        receiptItemID: this.addAttachmentToReceipt ? null : this.newReceiptItemID,
        photoFileData: val2.File,
        photoFileType: val2.Filename,
      },
      {
        reportProgress: true,
      }
    );
    return this.HttpClient.request(val2.Filedata.upload).subscribe(
      (event: HttpEvent<any>) => {
        switch (event.type) {
          case HttpEventType.UploadProgress:
            val2.Progress = Math.round((event.loaded / event.total) * 100);
            if (val2.Progress == 100) {
              val2.AttchDone = true;
              this.innerCounter++;
            }
            break;
          case HttpEventType.Response:
            this.submitCount++;
            this.openExpenseModal();
            val2.Filedata.result = event.body;
        }
      },
      error => (this.errorMsg = error.message)
    );
  }

  openExpenseModal(): void {
    if (this.submitCount != null && this.newFiles != null) {
      if (this.submitCount == this.newFiles.length && this.submitCount != 0) {
        this.formData.selectedAll = false;
        this.formData.fileDrop = null;
        this.formData.selectCount = 0;
        this.closeModal3();
        const modalRef = this.ngbModalService.open(ConfirmationModalComponent, { size: 'lg', backdrop: 'static' });
        modalRef.componentInstance.data = this.upload;
        modalRef.componentInstance.selectedEmployee = this.employeeInfo;
        modalRef.componentInstance.errorMsg = this.errorMsg;
        modalRef.result.then(() => {
          this.formData.selectedAll = false;
          this.formData.selectCount = 0;
        });
      }
    }
  }

  quickAdd(): void {
    setTimeout(() => {
      this.newReceiptID = null;
      if (this.formData.fileDrop.length > 0) {
        this.submitCount = 0;
        let hour: any = new Date().getHours();
        let APM = ' AM';
        if (hour == 24) {
          hour = 0;
          APM = ' PM';
        }
        if (hour == 12) {
          APM = ' PM';
        }
        if (hour > 12) {
          hour = hour - 12;
          APM = ' PM';
        }
        if (hour < 10) {
          hour = '0' + hour.toString();
        }
        let min: any = new Date().getMinutes();
        if (min < 10) {
          min = '0' + min;
        }
        let sec: any = new Date().getSeconds();
        if (sec < 10) {
          sec = '0' + sec;
        }
        const receiptID = -1;
        const receiptItemID = -1;
        const expenseDateStr = moment().format('YYYY-MM-DD');
        const description = 'Quick Add at ' + hour + ':' + min + ':' + sec + APM;
        const userKeyId = this.formData.selectedEmployee == null ? this.employeeInfo.UserKeyID : this.formData.selectedEmployee.UserKeyID;

        this.employeeService
          .insertUpdateReceipt(receiptID, userKeyId, this.employeeInfo.PRCo, description, expenseDateStr)
          .then((response: any) => {
            this.employeeService
              .insertUpdateReceiptItem(receiptItemID, response.newID)
              .then((itemResponse: any) => {
                if (itemResponse.success) {
                  this.openModal3();
                  this.upload = response;
                  this.upload.receiptItemID = itemResponse.newID;
                  this.newReceiptID = response.newID;
                  this.newReceiptItemID = itemResponse.newID;
                  this.newFiles = [];
                  this.fileData = [];

                  for (let i = 0; i < this.formData.fileDrop.length; i++) {
                    this.formData.fileDrop[i].nameEdit = '';
                    for (
                      let y = 0;
                      y < this.formData.fileDrop[i].name.substr(0, this.formData.fileDrop[i].name.lastIndexOf('.') + 1).length;
                      y++
                    ) {
                      if (
                        this.formData.fileDrop[i].name[y] != ' ' &&
                        this.formData.fileDrop[i].name[y] != '&' &&
                        this.formData.fileDrop[i].name[y] != '*' &&
                        this.formData.fileDrop[i].name[y] != ':' &&
                        this.formData.fileDrop[i].name[y] != ';' &&
                        this.formData.fileDrop[i].name[y] != '|' &&
                        this.formData.fileDrop[i].name[y] != '=' &&
                        this.formData.fileDrop[i].name[y] != ',' &&
                        this.formData.fileDrop[i].name[y] != '.' &&
                        this.formData.fileDrop[i].name[y] != '/' &&
                        this.formData.fileDrop[i].name[y] != '"' &&
                        this.formData.fileDrop[i].name[y] != '[' &&
                        this.formData.fileDrop[i].name[y] != ']'
                      )
                        this.formData.fileDrop[i].nameEdit += this.formData.fileDrop[i].name[y];
                    }
                    this.formData.fileDrop[i].nameEdit += this.formData.fileDrop[i].name.substr(
                      this.formData.fileDrop[i].name.lastIndexOf('.'),
                      this.formData.fileDrop[i].name.length
                    );
                  }

                  for (let i = 0; i < this.formData.fileDrop.length; i++) {
                    let n = 0;
                    this.innerCounter = 0;
                    this.readFile(this.formData.fileDrop[i], (e, filename: string) => {
                      setTimeout(() => {
                        this.fileData.push({ data: e.target.result.toString().split(','), size: e.total, name: filename });
                        if (n == this.formData.fileDrop.length - 1) {
                          this.fileData.forEach(val => {
                            this.formData.fileDrop.forEach(val2 => {
                              if (val2.size == val.size && val.name == val2.name) {
                                this.newFiles.push({
                                  File: val.data[1],
                                  Filename: val2.nameEdit,
                                  Filedata: val2,
                                  Type: val.data[0].split('/')[0],
                                });
                              }
                            });
                          });
                          if (this.formData.fileDrop && this.formData.fileDrop.length >= 1) {
                            this.newFiles.forEach(val2 => {
                              if (val2.Progress != 100 && val2.File != null) {
                                this.uploadFiles(val2);
                              }
                            });
                          }
                        }
                        n++;
                      });
                    });
                  }
                }
              })
              .catch((error: any) => {
                this.errorMsg = error?.error?.error ?? 'An error has occured.';
              });
          })
          .catch((error: any) => {
            this.errorMsg = error?.error?.error ?? 'An error has occured.';
          });
      }
    });
  }

  openGlobalNav(): void {
    document.getElementById('globalSideNav').style.width = '100%';
    this.menu = [];
    this.hotlistMenu = false;
    this.userNameMenu = false;
  }

  groupModules(): void {
    this.moduleCategories = [];
    this.moduleCategoriesMobile = [];
    this.hotlistItems = [];

    let hotlistItems: PortalModule[] = [];
    const moduleCategories = [];
    const moduleCategoriesMobile = [];

    const temp = {};
    let temp2 = {};
    let tempMobile = [];
    const temp2Mobile = [];

    this.modules.forEach(val => {
      if (val.ModuleCatgSeq != 100) {
        const moduleExists = Object.prototype.hasOwnProperty.call(temp, val.ModuleCatgName);
        if (moduleExists && val.ModuleCatgName != null && val.ModuleShowInNav) {
          temp[val.ModuleCatgName].push(val);
        } else if (val.ModuleCatgName != null && val.ModuleShowInNav) {
          temp[val.ModuleCatgName] = [];
          temp[val.ModuleCatgName].push(val);
        }
      }
    });

    hotlistItems = this.modules.filter(m => m.IsHotlistItem && m.ModuleShowInNav);
    hotlistItems = new OrderByPipe().transform(hotlistItems, 'ModulePrettyShortName', 'asc');
    for (const key in temp) {
      let groupCount = 0;
      let managementCount = 0;
      const tempDetail = temp[key];
      tempDetail.forEach(val => {
        if (val.ModuleCatgID == 1) {
          if (temp2['My Tools'] == null) temp2['My Tools'] = {};
          if (temp2['Management'] == null) temp2['Management'] = {};
          if (val.ModuleSubCatgID == 1 || val.ModuleSubCatgID == 18 || val.ModuleSubCatgID == 33) {
            if (Object.prototype.hasOwnProperty.call(temp2['My Tools'], val.ModuleSubCatgSeq + ',' + val.ModuleSubCatgName)) {
              temp2['My Tools'][val.ModuleSubCatgSeq + ',' + val.ModuleSubCatgName].push(val);
            } else {
              temp2['My Tools'][val.ModuleSubCatgSeq + ',' + val.ModuleSubCatgName] = [];
              temp2['My Tools'][val.ModuleSubCatgSeq + ',' + val.ModuleSubCatgName].push(val);
            }
          } else {
            managementCount++;
            if (Object.prototype.hasOwnProperty.call(temp2['Management'], val.ModuleSubCatgSeq + ',' + val.ModuleSubCatgName)) {
              temp2['Management'][val.ModuleSubCatgSeq + ',' + val.ModuleSubCatgName].push(val);
            } else {
              temp2['Management'][val.ModuleSubCatgSeq + ',' + val.ModuleSubCatgName] = [];
              temp2['Management'][val.ModuleSubCatgSeq + ',' + val.ModuleSubCatgName].push(val);
              groupCount++;
            }
          }
          if (managementCount == 0) {
            delete temp2['Management'];
          }
        } else {
          if (Object.prototype.hasOwnProperty.call(temp2, val.ModuleSubCatgSeq + ',' + val.ModuleSubCatgName)) {
            temp2[val.ModuleSubCatgSeq + ',' + val.ModuleSubCatgName].push(val);
          } else {
            temp2[val.ModuleSubCatgSeq + ',' + val.ModuleSubCatgName] = [];
            temp2[val.ModuleSubCatgSeq + ',' + val.ModuleSubCatgName].push(val);
            groupCount++;
          }
        }
      });
      const temp3 = [];
      for (const key3 in temp2) {
        temp3.push({ catName: key3, items: temp2[key3], catID: tempDetail[0].ModuleCatgID });
      }
      moduleCategories.push({ barName: key, list: temp3, catID: tempDetail[0].ModuleCatgID, groupCount: groupCount });
      temp2 = {};
    }

    // insert Office Tools category before Approval if present, otherwise at the end
    if (this.showOfficeRoute) {
      //check if Approval is on the navbar
      let insertIndex = moduleCategories.indexOf(moduleCategories.find(c => c.barName == 'Approval'));
      //if Approval is not on the navbar, check for Admin
      if (insertIndex == -1) {
        insertIndex = moduleCategories.indexOf(moduleCategories.find(c => c.barName == 'Admin'));
      }
      //place Office tools to the left of approval, or admin (if no approval), else place after everything else
      insertIndex = insertIndex > -1 ? insertIndex : moduleCategories.length;
      moduleCategories.splice(insertIndex, 0, { barName: 'Office Tools', list: [], catID: 99, groupCount: 0 });
    }

    //group modules by category
    this.modules.forEach(module => {
      if (module.ModuleCatgSeq != 100 && module.ModuleShowInNav) {
        if (tempMobile[module.ModuleCatgSeq] == null) {
          tempMobile[module.ModuleCatgSeq] = [];
        }
        tempMobile[module.ModuleCatgSeq].push(module);
      }
    });

    //remove unused array values
    tempMobile = tempMobile.filter(function (n) {
      return n != undefined;
    });
    for (const catgKey in tempMobile) {
      moduleCategoriesMobile[catgKey] = {};
      temp2Mobile[catgKey] = {};
      const category = tempMobile[catgKey];
      category.forEach(module => {
        if (moduleCategoriesMobile[catgKey].CategoryName == null) {
          moduleCategoriesMobile[catgKey].CategoryName = module.ModuleCatgName;
          moduleCategoriesMobile[catgKey].ModuleCount = 0;
        }
        const subCategory = module.ModuleSubCatgName != null ? module.ModuleSubCatgName : 0;
        if (temp2Mobile[catgKey][subCategory] == null) {
          temp2Mobile[catgKey][subCategory] = [];
        }
        temp2Mobile[catgKey][subCategory].push(module);
        moduleCategoriesMobile[catgKey].ModuleCount++;
      });
    }

    for (const catgKey in temp2Mobile) {
      moduleCategoriesMobile[catgKey].Modules = [];
      const category = temp2Mobile[catgKey];
      for (const subCatgKey in category) {
        const subCategory = category[subCatgKey];
        if (subCatgKey != 'CategoryName' && subCatgKey != 'ModuleCount') {
          subCategory.sort(function (a, b) {
            if (a.ModuleSortSeq < b.ModuleSortSeq) return -1;
            if (a.ModuleSortSeq > b.ModuleSortSeq) return 1;
            return 0;
          });
          subCategory.forEach(val => {
            moduleCategoriesMobile[catgKey].Modules.push(val);
          });
        }
      }
    }

    this.hotlistItems = hotlistItems;
    this.moduleCategories = moduleCategories;
    this.moduleCategoriesMobile = moduleCategoriesMobile;

    // insert Office Tools category before Approval if present, otherwise at the end
    if (this.showOfficeRoute) {
      //check if Approval is on the navbar
      let insertIndex = this.moduleCategoriesMobile.indexOf(this.moduleCategoriesMobile.find(c => c.CategoryName == 'Approval'));
      //if Approval is not on the navbar, check for Admin
      if (insertIndex == -1) {
        insertIndex = this.moduleCategoriesMobile.indexOf(this.moduleCategoriesMobile.find(c => c.CategoryName == 'Admin'));
      }
      //place Office tools to the left of approval, or admin (if no approval), else place after everything else
      insertIndex = insertIndex > -1 ? insertIndex : this.moduleCategoriesMobile.length;
      this.moduleCategoriesMobile.splice(insertIndex, 0, { CategoryName: 'Office Tools', ModuleCount: 0, Modules: [] });
    }
  }

  openPasswordWarningModal(): void {
    this.ngbModalService.open(PasswordWarningModalComponent, { size: 'md', backdrop: 'static', keyboard: false });
  }

  paperLessModal(): void {
    const modalRef = this.ngbModalService.open(PaperlessModalComponent, { size: 'lg', backdrop: 'static' });
    modalRef.componentInstance.data = this.employeeInfo;
    modalRef.componentInstance.portalSettings = this.portalSettings;

    modalRef.result.then(() => {
      this.homeService.getEmployeeInfo().then(response => {
        this.employeeInfo = response;
      });
      this.closeModal();
    });
  }

  async postClockAction($event: any, ignoreLocation: boolean): Promise<void> {
    $event.preventDefault();
    $event.stopPropagation();
    this.performingClockAction = true;
    this.requestObj = {};
    this.licensedUser = {};
    let lineTypes = [];
    if (this.enabledLineTypesInClockIn != null) {
      const enabledLineTypesInClockInList = this.enabledLineTypesInClockIn.split(',');
      if (enabledLineTypesInClockInList.includes('S')) {
        this.licensedUser = await this.homeService.getLicenseCounts(this.employeeInfo.PRCo, this.employeeInfo.Employee);
      }
      lineTypes = this.clockinoutService.getEnabledLineTypes(this.licensedUser, this.employeeInfo.IsActiveTechnician);
    }

    if (!this.clockStatus.ClockAction && lineTypes.length > 0) {
      const initialState = {
        portalSettings: this.portalSettings,
        employeeInfo: this.employeeInfo,
        lastClockinType: this.clockStatus.LastUsedClockinType ?? 'J',
        lineTypes: lineTypes,
        backdrop: 'static',
      };

      const modalRef = this.modalService.show(ClockinJobModalComponent, { initialState, ignoreBackdropClick: true, keyboard: true });

      modalRef.onHide.subscribe(() => {
        const result = modalRef.content;
        if (result.userAction == 'cancel') {
          this.performingClockAction = false;
        } else {
          if (result != null && result.userAction == 'Clock In') {
            if (!ignoreLocation && this.position?.coords) {
              this.requestObj.gPSLat = this.position.coords.latitude;
              this.requestObj.gPSLong = this.position.coords.longitude;
            }
            if (result.formData.lineType == 'J') {
              if (result.formData.selectedJob != null) {
                this.requestObj.jCJMKeyID = result.formData.selectedJob.JCJMKeyID;
              }
              if (result.formData.selectedPhase != null) {
                this.requestObj.jCJPKeyID = result.formData.selectedPhase.JCJPKeyID;
              }
            } else if (result.formData.lineType == 'S') {
              this.requestObj.sMTripID = result.formData.workOrder?.SMTripID;
              this.requestObj.sMWorkOrderScopeID = result.formData.scope?.SMWorkOrderScopeID;
              this.requestObj.sMPayType = result.formData.payType?.DatabaseValue;
            }
            const currentTime = moment();
            this.requestObj.clockTimeString = currentTime.format('MM/DD/YYYY h:mm:ss a');
            this.homeService.postClockAction(this.requestObj).then((response: any) => {
              if (response.success) {
                this.getClockInStatus();
              } else {
                this.performingClockAction = false;
                const initialState = {
                  modalData: { modalTitle: 'An Error Ocurred', modalMessage: response.error },
                  backdrop: 'static',
                };
                this.modalService.show(ErrorModalComponent, { initialState, ignoreBackdropClick: true, keyboard: true });
              }
            });
          } else {
            this.performingClockAction = false;
          }
        }
      });
    } else {
      if (this.portalSettings.RequireSignClockOut.ConfigValue == '1' && this.clockStatus.ClockAction) {
        const initialState = {
          portalSettings: this.portalSettings,
          employeeInfo: this.employeeInfo,
          backdrop: 'static',
        };

        const modalRef = this.modalService.show(ClockoutModalComponent, { initialState, ignoreBackdropClick: true, keyboard: true });

        modalRef.onHide.subscribe(() => {
          const result = modalRef.content.userAction;
          if (result == 'close') {
            this.performingClockAction = false;
          } else {
            if (!ignoreLocation && this.position?.coords) {
              this.requestObj.gPSLat = this.position.coords.latitude;
              this.requestObj.gPSLong = this.position.coords.longitude;
            }
            this.requestObj.signatureData = result;
            const currentTime = moment();
            this.requestObj.clockTimeString = currentTime.format('MM/DD/YYYY h:mm:ss a');
            this.homeService.postClockAction(this.requestObj).then((response: any) => {
              if (response.success) {
                this.getClockInStatus();
              } else {
                this.performingClockAction = false;
                const initialState = {
                  modalData: { modalTitle: 'An Error Ocurred', modalMessage: response.error },
                  backdrop: 'static',
                };
                this.modalService.show(ErrorModalComponent, { initialState, ignoreBackdropClick: true, keyboard: true });
              }
            });
          }
        });
      } else {
        if (!ignoreLocation && this.position?.coords) {
          this.requestObj.gPSLat = this.position.coords.latitude;
          this.requestObj.gPSLong = this.position.coords.longitude;
        }
        const currentTime = moment();
        this.requestObj.clockTimeString = currentTime.format('MM/DD/YYYY h:mm:ss a');
        this.homeService.postClockAction(this.requestObj).then((response: any) => {
          if (response.success) {
            this.getClockInStatus();
          } else {
            this.performingClockAction = false;
            const initialState = {
              modalData: { modalTitle: 'An Error Ocurred', modalMessage: response.error },
              backdrop: 'static',
            };
            this.modalService.show(ErrorModalComponent, { initialState, ignoreBackdropClick: true, keyboard: true });
          }
        });
      }
    }
  }

  unbindViewpointID(): void {
    const initialState = {
      portalSettings: this.portalSettings,
      employeeInfo: this.employeeInfo,
      modalData: {
        modalTitle: 'Unlink Viewpoint ID',
        modalMessage: 'Are you sure you want to unbind your Keystyle account from your Viewpoint account?',
        modalAction: 'Unbind',
        closeButtonText: 'Cancel',
        warningLevel: 'primary',
      },
      backdrop: 'static',
    };

    const modalRef = this.modalService.show(WarningModalComponent, { initialState, ignoreBackdropClick: true, keyboard: true });

    modalRef.onHide.subscribe(() => {
      const result = modalRef.content.userAction;
      if (result == 'Unbind') {
        this.homeService.unbindViewpointID().then((response: any) => {
          if (response.success) {
            const initialState = {
              portalSettings: this.portalSettings,
              employeeInfo: this.employeeInfo,
              modalData: {
                modalTitle: 'Unlink Viewpoint ID',
                modalMessage: 'Keystyle account unbound from Viewpoint ID successfully.',
                closeButtonText: 'Close',
                alertLevel: 'success',
              },
              backdrop: 'static',
            };
            this.modalService.show(AlertModalComponent, { initialState, ignoreBackdropClick: true, keyboard: true });
          } else {
            const initialState = {
              portalSettings: this.portalSettings,
              employeeInfo: this.employeeInfo,
              modalData: {
                modalTitle: 'Unlink Viewpoint ID',
                modalMessage: response.error,
                closeButtonText: 'Close',
                alertLevel: 'danger',
              },
              backdrop: 'static',
            };
            this.modalService.show(AlertModalComponent, { initialState, ignoreBackdropClick: true, keyboard: true });
          }
        });
      }
    });
  }

  getClockInStatus(): void {
    const currentTime = moment();
    const currentTimeString = currentTime.format('MM/DD/YYYY h:mm:ss a');
    this.homeService
      .getClockInStatus(false, currentTimeString)
      .then(response => {
        if (response != null) {
          this.performingClockAction = false;
          this.clockStatus = response;
          this.getLocation();
          if (this.clockStatus.ClockTime != null) {
            this.clockStatus.ClockTimeDisplay = moment(parseInt(this.clockStatus.ClockTime.substring(6)))
              .utc()
              .format(this.utilityService.getDateFormat().toUpperCase() + ' hh:mm a');
          }
        }
      })
      .catch(error => {
        this.performingClockAction = false;
        this.errorMsg = error?.error?.error ?? 'An error has occured';
      });
  }

  getLocation(): void {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(position => {
        this.requestingLocation = false;
        this.geolocationEnabled = true;
        this.position = position;
      });
    } else {
      this.requestingLocation = false;
    }
  }

  subStringFromComma(text: string): string {
    const temp = text.split(',');
    return temp[1];
  }

  closeMenusSection(number: any, type: any): void {
    if (number != null && this.menu[number]) {
      this.menu[number] = false;
      return;
    } else if (type === 'h' && !number && this.hotlistMenu) {
      this.hotlistMenu = false;
      return;
    } else if (type === 't' && !number && this.teamMenu) {
      this.teamMenu = false;
      return;
    } else if (type === 'n' && !number && this.userNameMenu) {
      this.userNameMenu = false;
      return;
    } else {
      for (let i = 0; i < this.moduleCategories?.length; i++) {
        this.menu[i] = false;
      }
      this.hotlistMenu = false;
      this.userNameMenu = false;
      this.teamMenu = false;

      if (number != null) {
        this.menu[number] = true;
      }
      if (type === 'h' && !number) {
        this.hotlistMenu = true;
      }
      if (type === 't' && !number) {
        this.teamMenu = true;
      }
      if (type === 'n' && !number) {
        this.userNameMenu = true;
      }
    }
  }

  logout(): void {
    sessionStorage.clear();
    this.utilityService.isLoggedOut = true;
    this.window.location.href = '/Account/Logout';
  }

  openModal(): void {
    document.getElementById('fadeNav').style.display = 'block';
  }

  closeModal(): void {
    document.getElementById('fadeNav').style.display = 'none';
  }

  //approvedTimecardsChanged  &  approvedDependentChanged
  getEmployeeInfo(): void {
    this.homeService.getEmployeeInfo().then(response => {
      this.employeeInfo = response;
      this.calculateUnapprovedRequestCount();
    });
  }

  //approvedTimeoffChanged
  modifyApprovedTimeOff(): void {
    this.employeeInfo.TimeOffCount--;
    if (this.employeeInfo.TimeOffCount < 0) {
      this.employeeInfo.TimeOffCount = 0;
    }
    this.calculateUnapprovedRequestCount();
  }

  closeGlobalNav(): void {
    document.getElementById('globalSideNav').style.width = '0';
    this.closeMenusSection(null, null);
  }
}
